module.exports = __webpack_public_path__ + "../static/img/es.8c035d9c.png";